import { isNil, omitBy } from 'lodash';

import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/search/search/`;

export const QueryKey = (payload?: Payload) => ['v3', 'search', 'search', omitBy(payload, isNil)] as const;

export type Payload = {
    query: string;
    size?: number;
    skip?: number;
    fields: string[];
};

export type Response = {
    exactMatch?: Models.Search.Item;
    maxSearchSize: number;
    occurrences?: {
        families?: Record<string, number>;
        types?: Record<string, number>;
    };
    search: Models.Search.Item[];
    total: number;
};
